/**
 * Common Scripts
 */
require('common/common-scripts.js');

/**
 * Modular Specific Scripts
 */
require('components/slider.js');
require('components/video-loader.js');
require('components/discount-banner.js');
require('components/tab-carousel.js');
require('modules/choose-your-plan.js');
require('modules/choose-your-language.js');
require('contact/contact-org-controller.js');
require('iframes/iframe-loader.js');
require('premium/premium-header-controller.js');
require('third-party/script-trustpilot.js');
require('third-party/script-zendesk.js');
require('modules/sticky-nav.js');
require('modules/fade-in.js');
require('premium/card-plans-controller.js');
require('tracking/pages/tracking-pages.js');
require('tracking/pages/tracking-premium.js');
